import styled, { css } from 'styled-components';
import { ImageWrapper } from '@mlb/react-patterns/v4/components/Image/image.style';
import { PlayerMatchupWrapper } from '@mlb/react-patterns/v4/components/PlayerMatchup/playerMatchup.style';
import { MatchupWrapper as ParentMatchupWrapper } from '../Matchup/Matchup.style';
import { MatchupWrapper, PlayerDuelWrapper } from '../PlayerDuel/PlayerDuel.style';
import { PitchFxWrapper } from '../PitchFx/PitchFx.style';
import { liveViewsTypes } from '../themes/liveViewsTypes';
import { LayoutWrapper as Layout } from './Live.style';
import { PitchByPitchBaseWrapper } from '../AtBat/atbat.style';
import { PlayPitchWrapper } from '../Play/play/PlayPitches.style';
import { MidAdWrapper } from '../Ads/components/ad.style';
import GDBREAKPOINTS from '../themes/breakpoints';

const { SINGLENARROW } = liveViewsTypes;
const { SM_MIN, MD_MIN } = GDBREAKPOINTS;

export const LayoutWrapper = styled(Layout)`
    ${PitchFxWrapper} {
        width: auto;
        margin: 0;
        height: ${({ $useFullViewport }) => !$useFullViewport ? '100%' : '100vh'};
    }
    ${ParentMatchupWrapper} {
        padding: 0 !important;
        ${PlayerDuelWrapper} {
            margin-top: 0;
            ${MatchupWrapper} {
                width: auto;
                padding: var(--gameday-section-padding-sm) ${({ type }) => type === SINGLENARROW ? '0' : 'var(--gameday-section-padding-sm)'};

                ${({ type }) => {
                    if (type === SINGLENARROW) {
                        return `
                            ${PlayerMatchupWrapper} {
                                width: 48px;
                            }
                            ${ImageWrapper} {
                                width: 48px;
                            }
                        `;
                    }
                }}
            }
        }
    }
`;

export const LinkWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 14px;
    pointer-events: auto;
    user-select: auto;
    a {
        color: var(--gameday-primary-font-color);
        margin: 0px 6px;
        font-size: 14px;
        font-weight: 700;
    }
`;

export const PitchByPitchMiniHomeWrapper = styled(PitchByPitchBaseWrapper)`
    width: 100%;
    border-radius: 0;
    margin-top: 0;
    height: 100%;

    ${({ $useFullViewport }) => !$useFullViewport && `
        aspect-ratio: 4 / 3;

        @media (min-width: ${SM_MIN}) {
            aspect-ratio: 16 / 9;
        }
    `}


    .field {
        ${({ $useFullViewport, $strikezoneOnly }) => {
            if ($useFullViewport) {
                return css`
                    margin: 250px 0 -14% 50%;
                    transform: ${$strikezoneOnly ? 'translate(-50%, calc(50vh - 85%))' : 'translate(-50%, calc(50vh - 108%))'};
                `;
            } else {
                return css`
                    margin: 0 0 -14% 50%;
                    transform: translate(-50%, calc(100vw - 90%));

                    @media (min-width: ${SM_MIN}) {
                        transform: translate(-50%, calc(50vw - 80%));
                    }

                    @media (min-width: ${MD_MIN}) {
                        transform: translate(-50%, -20%);
                    }
                `;
            }
        }}
    }

    ${PlayPitchWrapper} {
        padding-left: 40px;
        width: 100%;
    }

    ${MidAdWrapper} {
        top: 35%;
    }
`;
